<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2015</span></div>
    </div>
    <div class="view-wrap yr2015">


<FullYearStats fullGames='15' fullCompletions='428' fullAttempts='627' fullYards='4,870' fullPct='68.3' fullTDs='32' fullINTs='11' fullYPG='324.7' fullRating='101.0'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
     
      <div class="year-summary-text-flex">


              <h1 class="content-headline">6-Time NFL Passing leader</h1>

      <div class="copy-paragraph">
      Despite missing a game with a shoulder injury in 2015, Brees was able to capture the league's passing yardage title for an NFL-record sixth time, completeing 428-of-627 passes (68.3%) for 4,870 yards, 32 touchdowns, and a 101.0 passer rating.
      <br/><br/>

      The Saints started-off cold in 2015, losing all of their preseason games and falling in their first 3 regular season games, two of which were against divisional opponents. They would finish the season 7-9 with the defense giving up the most passing touchdowns in league history (45).
      <br/><br/>


      Despite a tough season for the team, Brees' completions and completion percentage were second-best across the NFL, while his 32 touchdowns tied for the fourth-highest total in the league.
      <br/><br/>


      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2015-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees and the entire Saints offensive line pose for a photo together">
      </div>


<div class="awards-wrapper">
        <div class="awards-headline">2015 Awards</div>
        <ul>

          <li><img :src="require('@/assets/castrol-edge.png')" alt="Castrol Edge Logo"> Castrol Edge Clutch Performer of the Year</li>
          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 
      </div> <!--end text-flex-->
    </div>
  </div>


   <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2015 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
</div>



<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2015 Touchdown Tally"> 2015 TOUCHDOWN TALLY</h1>
</div>





</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2015 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2015 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2015 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2015 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2015 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2015 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2015 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2015 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2014">«2014</router-link></div>
  <div class="year-pagination-section year-pagination-current">2015</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2016">2016»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue';

import axios from 'axios';

export default {
  name: 'yr2015',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2015 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2015-top.jpg",
      image1: "brees-2015-slide-1.jpg",
      image2: "brees-2015-slide-2.jpg",
      image3: "brees-2015-slide-3.jpg",
      image4: "brees-2015-slide-4.jpg",
      image5: "brees-2015-slide-5.jpg",
      image6: "brees-2015-slide-6.jpg",
      image7: "brees-2015-slide-7.jpg",
      image8: "brees-2015-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2015;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

 mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

  },

created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 68.3,
                  y: 4870,
                  r: 32/1.5
                }
              ]
      },
      {
        "label": "Tom Brady",
        "backgroundColor": "#002244",
        "borderColor": "#C60C30",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 64.4,
                  y: 4770,
                  r: 36/1.5
                }
              ]
      },
      {
        "label": "Russell Wilson",
        "backgroundColor": "#69BE28",
        "borderColor": "#002244",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 68.1,
                  y: 4024,
                  r: 34/1.5
                }
              ]
      },
      {
        "label": "Carson Palmer",
        "backgroundColor": "#97233F",
        "borderColor": "#000000",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 63.7,
                  y: 4671,
                  r: 35/1.5
                }
              ]
      },
       {
        "label": "Kirk Cousins",
        "backgroundColor": "#773141",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 69.8,
                  y: 4166,
                  r: 29/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 5,
                right: 20,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards, ' + tooltipItem.xLabel.toLocaleString() + ' Completion %, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2015.vue